export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'eca5577c-3ff7-4bd2-bd88-2b9aa393b253';
export const MODAL_CLOSE_SEC = 2.5;
